import {twJoin} from "tailwind-merge";

export function AnankeTempFormSectionTitle({title, className}: {title: string; className?: string}) {
    return <div className={twJoin("w-full text-ds-font-heading-medium", className)}>{title}</div>;
}
